import React, { useEffect, useState } from 'react'
import { Button, Checkbox, FormControlLabel, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography, } from '@mui/material'
import { getUserRollColumnDefs } from '../constants'
import EditIcon from '@mui/icons-material/Edit'
import TableCellTooltip from '../../../common/TableCellTooltip'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import { focusElemnt, navigation3, navigation1 } from '../../../common/helper'
import Lineinput from '../../../common/lineinput'
import { Item } from '../../../common/snippets'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Box } from '@mui/system'
import EditRightsModal from './EditRightsModal'
import LuggageRightsModal from './LuggageRightsModal/index'
import BookAccSpecialModalJsx from './BookAccSpecialModal.jsx'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded'
import { userRollRightEditRights, userRRAddUser, userRRBookAcSpecialRights, userRRCashBookRights } from '../../../../store/branchAndUserMaster/BUMAction'
import moment from 'moment/moment'
import SuccessfullModal from '../../../common/SuccessfullModal'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import { useTranslation } from '../../../../i18n/I18nProvider'


const UserRollRightsTable = (props) => {

    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const userRollColumnDefs = getUserRollColumnDefs(translations)
    const { data, updateModal, tableData, updateAlertError, userRollRightEditRights, userRRAddUser, userRRCashBookRights, userRRBookAcSpecialRights, onLoad,searchData, setSearchData,loginData } = props
    const { common } = data
    const { showModal, modalType } = { ...common }

    const editRights = { id: 'EditRightsUseRollRights', lrListLabel: 'Edit Rights User Roll Rights popup modal', isSaved: false }
    const luggageRights = { id: 'LuggageRightsUseRollRights', lrListLabel: 'Luggage Rights User Roll Rights popup modal', isSaved: false }
    const bookAccSpecialRights = { id: 'BookAccSpecialRights', lrListLabel: 'Book Acc. Special Rights popup modal', isSaved: false }
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    const [showTableData, setShowTableData] = useState([])
    const [categoryInp, setCategoryInp] = useState("")
    const [descriptionInp, setDescription] = useState("")
    const [activeCheckBox, setActiveCheckBox] = useState(1)
    const [editRightsData, setEditRightsData] = useState([])
    const [luggageRightsData, setLuggageRightsData] = useState([])
    const [bookAcSpecialRightsData, setBookAcSpecialRightsData] = useState([])
    const [roleId, setRoleId] = useState(0)
    const [otpOnUserRights, setOtpOnUserRights] = useState(0)
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const [saveError, setSaveError] = useState({ error: false, message: "", })
    const [manageFocus, setManageFocus] = useState(false)


    useEffect(() => {
        let fiterData = tableData?.filter((val) =>
            (searchData.RoleName === "" || val?.RoleName?.toLocaleLowerCase()?.includes(searchData?.RoleName?.toString()?.toLocaleLowerCase())) &&
            (searchData.Description === "" || val?.Description?.toLocaleLowerCase()?.includes(searchData?.Description?.toLocaleLowerCase())) &&
            (searchData.ModifiedByUserName === "" || val?.ModifiedByUserName?.toLocaleLowerCase()?.includes(searchData?.ModifiedByUserName?.toLocaleLowerCase())) &&
            (searchData.ModifiedByBranchName === "" || val?.ModifiedByBranchName?.toLocaleLowerCase()?.includes(searchData?.ModifiedByBranchName?.toLocaleLowerCase())))
        setShowTableData(fiterData)
    }, [searchData])
    useEffect(() => {
        if (tableData?.length > 0) {
            const data = tableData?.map((val) => ({ ...val, isEdit: false, RoleNameV2: val.RoleName, IsActiveV2: val.IsActive, DescriptionV2: val.Description }))
            setShowTableData(data)
        } else {
            setShowTableData([])
        }
    }, [tableData])

    const EditRightsModals = () => {
        return <EditRightsModal editRightsData={editRightsData} roleId={roleId} otpOnUserRights={otpOnUserRights} onLoad={onLoad}loginData={loginData} />
    }
    const LuggageRightsModals = () => {
        return <LuggageRightsModal otpOnUserRights={otpOnUserRights} luggageRightsData={luggageRightsData} roleId={roleId} loginData={loginData} />
    }
    const BookAccSpecialModals = () => {
        return <BookAccSpecialModalJsx bookAcSpecialRightsData={bookAcSpecialRightsData} otpOnUserRights={otpOnUserRights} roleId={roleId} loginData={loginData} />
    }
    const handleSearchData = (event, field) => {
        setSearchData({ ...searchData, [field]: event.target.value })
    }
    const handleEdit = (index, item, type = "") => {
        let updatedRows = [...showTableData]
        if (index >= 0 && index <= updatedRows.length) {
            for (let i = 0; i < updatedRows?.length; i++) {
                if (i === index) {
                    updatedRows[index].isEdit = !updatedRows[index].isEdit
                } else {
                    updatedRows[i].isEdit = false
                }
            }
            setShowTableData(updatedRows)
            setManageFocus(true)
        }
    }

    const normalizeMasterName = (name) => (name || '').trim().toLowerCase()

    const LUGGAGE_REPORT_GROUPS = ['luggage reports', 'luggage reports v2']
    const GENERAL_SETTINGS_GROUP = 'general settings(luggage)'

    const reorderRightsGroups = (groups) => {
        const generalIndex = groups.findIndex((g) => normalizeMasterName(g.MasterName) === GENERAL_SETTINGS_GROUP)
        if (generalIndex === -1) {
            return groups
        }
        const luggageGroups = LUGGAGE_REPORT_GROUPS
            .map((name) => groups.find((g) => normalizeMasterName(g.MasterName) === name))
            .filter(Boolean)
        if (luggageGroups.length === 0) {
            return groups
        }
        const withoutLuggage = groups.filter((g) => !LUGGAGE_REPORT_GROUPS.includes(normalizeMasterName(g.MasterName)))
        const insertAt = withoutLuggage.findIndex((g) => normalizeMasterName(g.MasterName) === GENERAL_SETTINGS_GROUP) + 1
        return [...withoutLuggage.slice(0, insertAt), ...luggageGroups, ...withoutLuggage.slice(insertAt)]
    }

    const groupData = (arr) => {
        const formatedData = []
        const groupedData = arr.reduce((result, item) => {
            const key = `${item.MasterID}`
            if (!result[key]) {
                result[key] = []
            } result[key].push(item)
            return result
        }, {})
        Object.keys(groupedData)?.map((item, i) => {
            const obj = {
                MasterName: groupedData[item]?.[0]?.MasterName,
                MasterID: groupedData[item]?.[0]?.MasterID,
                subData: groupedData[item]
            }
            formatedData.push(obj)
        })
        return reorderRightsGroups(formatedData)
    }

    const editRightsBtn = (item) => {
        setOtpOnUserRights(item.IsOtpOnUserRights)
        setRoleId(item?.RoleID)
        const obj = {
            RoleID: item?.RoleID,
            IsLuggage: 0
        }
        userRollRightEditRights(obj).then((res) => {
            if (res?.status == 'Success') {
                const formateData = groupData(res?.Data?.Table || [])
                setEditRightsData(formateData)
                setSearchData({RoleName: "", Description: "", ModifiedByUserName: "", ModifiedByBranchName: "",})
                updateModal(true, "EditRightsUseRollRights")
            } else {
                updateAlertError({ show: true, msg: res.ErrMessage, })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }

    const LuggageRightsBtn = (item) => {
        setOtpOnUserRights(item.IsOtpOnUserRights)
        setRoleId(item?.RoleID)
        const obj = {
            RoleID: item?.RoleID,
        }
        userRRCashBookRights(obj).then((res) => {
            if (res?.status == 'Success') {
                setLuggageRightsData(res?.Data)
                updateModal(true, "LuggageRightsUseRollRights")
            } else {
                updateAlertError({ show: true, msg: res.ErrMessage, })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const BookAcSpecialRightsBtn = (item) => {
        setOtpOnUserRights(item.IsOtpOnUserRights)
        setRoleId(item?.RoleID)
        const obj = {
            RoleID: item?.RoleID,
        }
        userRRBookAcSpecialRights(obj).then((res) => {
            if (res?.status == 'Success') {
                setBookAcSpecialRightsData(res?.Data)
                updateModal(true, "BookAccSpecialRights")
            } else {
                updateAlertError({ show: true, msg: res.ErrMessage, })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }

    const handleInputChange = (e, index, key) => {
        let newVal = [...showTableData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index][key] = e.target.value
            setShowTableData(newVal)
        }
        if (key == "Description") {
            setManageFocus(false)
            setTimeout(() => {
                focusElemnt("URRDescription")
            }, 0)
        }

    }
    const statusChange = (value, index) => {
        const updatedShowData = [...showTableData];
        updatedShowData[index].IsActive = value;
        setShowTableData(updatedShowData)
        setTimeout(() => {
            focusElemnt(`URRTableStatus-${index}`)
        }, 0)
    }

    const handleCrossBtn = (index) => {
        let newVal = [...showTableData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].RoleName = newVal[index].RoleNameV2
            newVal[index].Description = newVal[index].DescriptionV2
            newVal[index].IsActive = newVal[index].IsActiveV2
            newVal[index].isEdit = !newVal[index].isEdit
            setShowTableData(newVal)
            setTimeout(() => {
                focusElemnt(`editBtn-${index + 1}`)
            }, 0)
        }
    }
    const onAddUser = (isEditValue = false, item = "") => {
        if (categoryInp === "" && !isEditValue) {
            updateAlertError({ show: true, msg: bum.fillCategoryName || "Fill Category Name", nextId: "URRCatagoryNameInp" })
        } else if (descriptionInp === "" && !isEditValue) {
            updateAlertError({ show: true, msg: bum.fillDescription || "Fill Description", nextId: "URRDescription" })
        } else {
            if(isEditValue && item?.RoleName==""){
                updateAlertError({ show: true, msg: bum.fillCategoryName || "Fill Category Name", nextId: "URRCatagoryNameInp" })
            }else{
                const obj = {
                    RoleID: isEditValue ? item?.RoleID : 0,
                    CompanyID: loginData?.intCompanyID,
                    RoleName: isEditValue ? item?.RoleName : categoryInp,
                    Description: isEditValue ? item?.Description : descriptionInp,
                    IsActive: isEditValue ? item?.IsActive : activeCheckBox,
                    ModifiedByUser: loginData?.intUserID
                }
                userRRAddUser(obj).then((res) => {
                    if (res?.status == 'Success') {
                        setIsOpen({ ...isOpen, open: true, message: bum.userRoleSavedSuccessfullyNl || "User Role\nSaved Successfully!" })
                        setCategoryInp("")
                        setDescription("")
                        setSearchData({RoleName: "", Description: "", ModifiedByUserName: "", ModifiedByBranchName: "",})
                        setActiveCheckBox(1)
                    } else {
                        setSaveError({ ...saveError, error: true, message: res.Message })
                    }
                }).catch((err) => {
                    console.log("Error:", err)
                    setSaveError({ ...saveError, error: true, message: err })
                })
            }
        }
    }
    const InsideRowContent = ({ item, index }) => {
        return (
            <TableRow key={`DR-${index}`} >
                <TableCell style={{ height: '36px', textAlign: 'right', fontSize: '12px', color: '#666', }}>{index + 1}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{item?.RoleID}</TableCell>

                {
                    item.isEdit ? <>
                        <TableCell className="input--wrapper" style={{ fontSize: '12px', color: '#444444', padding: '0px 16px 0px 16px' }}>
                            <Item sx={{ width: '100%', padding: '0px' }}>
                                <input
                                    id={"URRCatagoryName"}
                                    name={`URRCatagoryName-${index}`}
                                    className='input--style'
                                    autoFocus={manageFocus}
                                    style={{ fontSize: "12px" }}
                                    type="text"
                                    value={item.RoleName}
                                    onChange={(e) => handleInputChange(e, index, "RoleName")}
                                    onKeyDown={(e) => navigation1(e, "URRDescription", "URRTblLeftIcon")}
                                />
                            </Item>
                        </TableCell>
                    </> :
                        <TableCellTooltip title={item.RoleName} data={item.RoleName} placement="bottom-start" textAlign="left" maxWidth="120px" />
                }
                {
                    item.isEdit ? <>
                        <TableCell className="input--wrapper" style={{ fontSize: '12px', color: '#444444', padding: '0px 16px 0px 16px' }}>
                            <Item sx={{ width: '100%', padding: '0px' }}>
                                <input
                                    id={"URRDescription"}
                                    name={`URRDescription-${index}`}
                                    className='input--style'
                                    style={{ fontSize: "12px" }}
                                    type="text"
                                    value={item?.Description}
                                    onChange={(e) => handleInputChange(e, index, "Description")}
                                    onKeyDown={(e) => navigation1(e, `URRTableStatus-${index}`, "URRCatagoryName")}
                                />
                            </Item>
                        </TableCell>
                    </> :
                        <TableCellTooltip title={item?.Description} data={item?.Description} placement="bottom-start" textAlign="left" maxWidth="140px" />
                }

                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }} >
                    <Item sx={{ padding: "0px" }} className="disabled-wrapper" onClick={() => editRightsBtn(item)} onKeyDown={(e) => navigation3(e, `URRLuggageRight-${index}`, index == 0 ? "Contains-8" : `Edit-${index - 1}`, () => { })} >
                        <Button id={`URREditRight-${index}`} className='receiveitembtn' variant="outlined" sx={{ width: "100%", fontSize: '10px !important', height: "24px" }}  >
                            {bum.editRights || "Edit Rights"}
                        </Button>
                    </Item>
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '10px !important', }}>
                    <Button id={`URRLuggageRight-${index}`} className='receiveitembtn' variant="outlined" sx={{ width: '100%', fontSize: '10px !important', height: "24px" }} onClick={() => LuggageRightsBtn(item)} onKeyDown={(e) => navigation3(e, `URRBASRight-${index}`, `URREditRight-${index}`, () => updateModal(true, "LuggageRightsUseRollRights"))} >
                        {bum.luggageRights || "Luggage Rights"}
                    </Button>
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '10px !important', }}>
                    {/*  */}
                    <Button id={`URRBASRight-${index}`} className='receiveitembtn' variant="outlined" sx={{ width: '100%', fontSize: '10px !important', height: "24px" }} onClick={() => BookAcSpecialRightsBtn(item)} onKeyDown={(e) => navigation3(e, `Edit-${index}`, `URRLuggageRight-${index}`, () => updateModal(true, "BookAccSpecialRights"))}  >
                        {bum.bookingAccountQrAndSpecialRights2 || "Booking, Account, QR and Special Rights"}
                    </Button>
                </TableCell>
                <TableCellTooltip title={item?.ModifiedByUserName} data={item?.ModifiedByUserName} placement="bottom-start" textAlign="left" maxWidth="120px" />
                <TableCellTooltip title={item?.ModifiedByBranchName} data={item?.ModifiedByBranchName} placement="bottom-start" textAlign="left" maxWidth="120px" />
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', }}>{moment(item?.ModifiedDatetime).format("HH:mm, DD-MMM-YY")}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>
                    <Checkbox
                        checked={item.IsActive === 1}
                        sx={{ padding: "0", borderRadius: "0" }}
                        id={`URRTableStatus-${index}`}
                        onChange={item.isEdit ? (e) => statusChange(e.target.checked ? 1 : 0, index) : ""}
                        onKeyDown={(e) => navigation3(e, `URRTblRightIcon`, "URRDescription", () => { })}
                    />
                </TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', cursor: "pointer" }}>
                    {item.isEdit ? (
                        <>
                            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', cursor: 'pointer' }}>
                                <span tabIndex={0} key={`checkMark-${index}`} id={`URRTblRightIcon`}
                                    onKeyDown={(e) => { navigation3(e, `URRTblLeftIcon`, `URRTableStatus-${index}`, () => onAddUser(true, item)) }}
                                >
                                    <CheckCircleOutlineRoundedIcon
                                        onClick={() => onAddUser(true, item)}
                                        style={{ color: '#4CAF50', height: '18px', width: '18px' }}
                                    />
                                </span>
                                <span
                                    key={`xMark-${index}`}
                                    tabIndex={0}
                                    id={`URRTblLeftIcon`}
                                    onKeyDown={(e) => {
                                        navigation3(e, `URRCatagoryName`, `URRTblRightIcon`, () => { handleCrossBtn(index, item); focusElemnt(`URRCatagory`) })
                                    }}
                                >
                                    <HighlightOffRoundedIcon
                                        style={{ color: '#F44336', height: '18px', width: '18px' }}
                                        // onClick={() => handleEdit(index, item)}
                                        onClick={() => handleCrossBtn(index, item)}
                                    />
                                </span>
                            </div>
                        </>
                    ) : (
                        <span
                            id={`Edit-${index}`} tabIndex={0}
                            style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                            onClick={() => handleEdit(index, item, "Edit")}
                            onKeyDown={(e) => navigation3(e, showTableData.length === index + 1 ? "URRCatagoryNameInp" : `URREditRight-${index + 1}`, `URRBASRight-${index}`, () => handleEdit(index, item))}
                        >
                            <EditIcon sx={{ marginRight: '3px' }} />
                            {bum.edit || "Edit"}
                        </span>
                    )}
                </TableCell>

            </TableRow>
        )
    }

    return (
        <>
            <TableContainer component={Paper} className='scrollBlue itemButtons userRollRightTable' style={{ maxHeight: '70vh', marginBottom: "5px" }} >
                <Table stickyHeader stickyFooter size="small" aria-label="a dense table" sx={{
                    '& .MuiTableCell-root': {
                        padding: '6px !important'
                    }
                }}>
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: "2" }}>
                        <TableRow>
                            {userRollColumnDefs.map((col, index) =>
                                <TableCell key={`TH-${index}`} style={{ ...col.headerSx, backgroundColor: '#DAEDFE', height: '36px', fontSize: '12px', fontWeight: '600', color: '#444' }}>{col.headerName}</TableCell>
                            )}
                        </TableRow>
                        <TableRow>
                            {userRollColumnDefs.map((col, index) => col.showfilter ?
                                <TableCell key={`FTH-${index}`} style={{ height: "36px" }}>
                                    <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                        <input
                                            id={`Contains-${index}`}
                                            className="field"
                                            name="cancelSearchInput"
                                            style={{ width: '100%', height: "24px" }}
                                            placeholder={bum.contains || "Contains"}
                                            autoComplete="off"
                                            value={searchData[col.field]}
                                            onChange={(e) => handleSearchData(e, col.field)}
                                            onKeyDown={(e) => navigation3(e, index === 8 ? `URREditRight-0` : index == 3 ? `Contains-7` : `Contains-${index + 1}`, index === 2 ? "URRSave" : index == 7 ? `Contains-3` : `Contains-${index - 1}`, () => { })}
                                        />
                                        <FilterAltIcon style={{ color: "#aaa" }} />
                                    </div>
                                </TableCell>
                                : <TableCell></TableCell>)}
                        </TableRow>
                    </TableHead>
                    {showTableData?.length <= 0 ? (
                        <>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={14}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: 'red',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span>{bum.noResultsFoundPleaseRefineYourSearchParametersAndSearchAgain || "No results found. Please refine your search parameters and search again."}</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </>
                    ) : showTableData.length > 0 ? (
                        <TableBody className="filter-data-row-BorderNone" sx={{ border: "none !important" }}>
                            {showTableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} />
                            ))}
                        </TableBody>
                    ) : (
                        ''
                    )}
                    <TableFooter style={{ position: `sticky`, height: "72px", backgroundColor: "#F5FAFE", bottom: `0`, zIndex: "2" }}>
                        <TableRow sx={{ width: "100%" }}>
                            <TableCell colSpan={12}>
                                <Grid container spacing={2} sx={{ display: "flex", alignItems: "center" }}>
                                    <Grid item md={0.5}>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Box className={'input--wrapper'} style={{ marginTop: "15px" }}>
                                            <Lineinput
                                                icon={"reset"}
                                                id={"URRCatagoryNameInp"}
                                                label={bum.categoryName || "Category Name"}
                                                value={categoryInp}
                                                type="text"
                                                name="PAN"
                                                sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                                onChange={(e) => setCategoryInp(e.target.value)}
                                                onKeyDown={(e) => navigation1(e, "URRDescription", `Edit-${showTableData.length - 1}`)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item md={5}>
                                        <Box className={'input--wrapper'} style={{ marginTop: "15px" }}>
                                            <Lineinput
                                                icon={"reset"}
                                                id={"URRDescription"}
                                                label={bum.description || "Description"}
                                                value={descriptionInp}
                                                type="text"
                                                name="PAN"
                                                sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                                onChange={(e) => setDescription(e.target.value)}
                                                onKeyDown={(e) => navigation1(e, "URRActive", "URRCatagoryNameInp")}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item md={1}>
                                        <Box className={'input--wrapper'} style={{ marginTop: "15px" }}>
                                            <Lineinput
                                                id={"UMPAN"}
                                                disabled={true}
                                                value={loginData?.strUserName}
                                                type="text"
                                                name="PAN"
                                                sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item md={1}>
                                        <Box className={'input--wrapper'} style={{ marginTop: "15px" }}>
                                            <Lineinput
                                                disabled={true}
                                                value={loginData?.strBranchName}
                                                type="text"
                                                name="PAN"
                                                sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item md={1}>
                                        <Box className={'input--wrapper'} style={{ marginTop: "15px" }}>
                                            <Lineinput
                                                disabled={true}
                                                value={moment(new Date()).format('HH:mm') + ', ' + moment(new Date()).format('DD-MMM-YY')}
                                                type="text"
                                                name="PAN"
                                                sx={{ margin: '8px', width: '100%', backgroundColor: "#F5FAFE" }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item md={0.7}>
                                        <FormControlLabel
                                            value="end"
                                            control={<Checkbox checked={activeCheckBox == 1} id='URRActive' />}
                                            onKeyDown={(e) => {
                                                navigation3(e, "URRAdd", 'URRDescription', () => { })
                                            }}
                                            label={
                                                <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                                    {bum.active || "Active"}
                                                </Typography>
                                            }
                                            onChange={(e) => {
                                                setActiveCheckBox(e.target.checked ? 1 : 0,)
                                            }}
                                            labelPlacement="end"
                                        />
                                    </Grid>
                                    <Grid item md={0.7}>
                                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "URRCatagory", "URRActive", () => { })}>
                                            <Button id="URRAdd" variant="contained" style={{ ...sx.fullHeight, ...sx.novp, width: "100%" }} className="btn btn-primary"
                                                onClick={()=>onAddUser(false,"")} >
                                                {bum.add || "Add"}
                                            </Button>
                                        </Item>
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
            {showModal && [editRights.id].includes(modalType) && EditRightsModals(editRights.id)}
            {showModal && [luggageRights.id].includes(modalType) && LuggageRightsModals(luggageRights.id)}
            {showModal && [bookAccSpecialRights.id].includes(modalType) && BookAccSpecialModals(bookAccSpecialRights.id)}
            <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); onLoad(); updateModal(false, "") }} open={isOpen?.open} title={isOpen?.message} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setSaveError({ ...saveError, error: false })} isError={true} open={saveError.error} title={saveError?.message} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError, userRollRightEditRights, userRRAddUser, userRRCashBookRights, userRRBookAcSpecialRights
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRollRightsTable)
